import { generateTestId } from "@client-shared";

export const setChangeAvailabilityPopoverTestId = (identifier: string): string => generateTestId("ChangeAvailabilityPopover", identifier);
